import BaseEntity from './base/BaseEntity.model';
import NameValue from './nameValue.model';

export default class Telefono extends BaseEntity{
    public tipoTelefonoId?: number = undefined;
    //public tipoTelefono?: NameValue  = undefined;
    public tipoTelefonoNombre?: any = undefined;
    constructor(public numero?: number, public extension?: string){
        super();
    }
}